module.exports = __webpack_public_path__ + "static/media/2_19.7a4dadb9.png";